"use client";

import { cn } from "@/lib/utils/cn";
import { useRef } from "react";
import { useDateSegment } from "react-aria";
import {
  type DateFieldState,
  type DateSegment as IDateSegment,
} from "react-stately";

interface DateSegmentProps {
  segment: IDateSegment;
  state: DateFieldState;
}

function DateSegment({ segment, state }: DateSegmentProps) {
  const ref = useRef(null);

  const {
    segmentProps: { ...segmentProps },
  } = useDateSegment(segment, state, ref);

  return (
    <div
      {...segmentProps}
      ref={ref}
      className={cn(
        "focus:bg-accent focus:text-accent-foreground focus:rounded-[2px] focus:outline-hidden",
        segment.type !== "literal" ? "px-[1px]" : "",
        segment.isPlaceholder ? "text-muted-foreground" : "",
      )}
    >
      {segment.text}
    </div>
  );
}

export { DateSegment };
